import styled from '@emotion/styled';
import { color, typography } from '@uniquegood/realworld-studio-design';

interface PageHeaderProps {
  title: string;
  subtitle: string;
}

const PageHeader = ({ title, subtitle }: PageHeaderProps) => {
  return (
    <HeaderSection>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </HeaderSection>
  );
};

export default PageHeader;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.h1`
  font-size: 24px;
  line-height: 28px;
  font-weight: ${typography.weight.bold};
  color: ${color.text_default};
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: ${typography.weight.regular};
  color: #555555;
  margin: 0;
`;
